var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobWorktype(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    fill: "#F9FAFB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    stroke: "#EAECF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 10.6667C16.6666 10.0467 16.6666 9.7367 16.5984 9.48236C16.4135 8.79218 15.8744 8.25308 15.1842 8.06815C14.9299 8 14.6199 8 13.9999 8C13.3799 8 13.0699 8 12.8156 8.06815C12.1254 8.25308 11.5863 8.79218 11.4014 9.48236C11.3333 9.7367 11.3333 10.0467 11.3333 10.6667M14.5333 17.6667H17.7999C17.9866 17.6667 18.0799 17.6667 18.1512 17.6303C18.214 17.5984 18.265 17.5474 18.2969 17.4847C18.3333 17.4134 18.3333 17.32 18.3333 17.1333V15.5333C18.3333 15.3466 18.3333 15.2533 18.2969 15.182C18.265 15.1193 18.214 15.0683 18.1512 15.0363C18.0799 15 17.9866 15 17.7999 15H14.5333C14.3466 15 14.2532 15 14.1819 15.0363C14.1192 15.0683 14.0682 15.1193 14.0362 15.182C13.9999 15.2533 13.9999 15.3466 13.9999 15.5333V17.1333C13.9999 17.32 13.9999 17.4134 14.0362 17.4847C14.0682 17.5474 14.1192 17.5984 14.1819 17.6303C14.2532 17.6667 14.3466 17.6667 14.5333 17.6667ZM10.5333 20H17.4666C18.5867 20 19.1467 20 19.5746 19.782C19.9509 19.5903 20.2569 19.2843 20.4486 18.908C20.6666 18.4802 20.6666 17.9201 20.6666 16.8V13.8667C20.6666 12.7466 20.6666 12.1865 20.4486 11.7587C20.2569 11.3824 19.9509 11.0764 19.5746 10.8847C19.1467 10.6667 18.5867 10.6667 17.4666 10.6667H10.5333C9.41315 10.6667 8.85309 10.6667 8.42527 10.8847C8.04895 11.0764 7.74299 11.3824 7.55124 11.7587C7.33325 12.1865 7.33325 12.7466 7.33325 13.8667V16.8C7.33325 17.9201 7.33325 18.4802 7.55124 18.908C7.74299 19.2843 8.04895 19.5903 8.42527 19.782C8.85309 20 9.41315 20 10.5333 20Z",
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobWorktype);
export default __webpack_public_path__ + "static/media/job-worktype.0f2548f9a2d79e5857943c3604f9966a.svg";
export { ForwardRef as ReactComponent };